/**
 * Feed Vuex
 */
import * as API from '@/endpoints'
import Axios from 'axios'
import Vue from 'vue'
import User from '@/store/modules/user'
import Resource from '@/store/modules/resource'
import Store from '@/store'
import _ from 'lodash'

export default {
  namespaced: true,
  state: {
    singleFeedView: {},
    isSingleFeedView: false,
    activeCareplan: null,
    isLoadingPostActivity: false,
    feedSingleItem: {},
    feedSingleItemActivities: {},
    feedSingleItemReplies: {},
    isReplying: false,
    isBookmarkLoading: false,
    scrollBelow: false,
    previewPlan: {},
    previewBrand: {},
    featuredUser: null,
    isFeaturedUserLoading: false,
    featuredSearchUser: {
      subscribers: {}
    },
    recentUsers: null,
    recentSearchUsers: {
      subscribers:{}
    },
    isLoadingRecentSearchUsers: false,
    isLoadingMoreRecentSearchUsers:false,
    activityLikes: {
      data:{},
      isLoading:false,
      isLikeActivityLoading:false
    }
  },
  getters: {
    isLoadingPostActivity: state => state.isLoadingPostActivity
  },
  mutations: {
    setIsLoadingActivityLikes(state, v) {
      Vue.set(state.activityLikes, 'isLoading', v);
    },
    setIsSingleFeedView(state, v) {
      Vue.set(state, 'isSingleFeedView', v);
    },
    setActivityLikes(state, v) {
      Vue.set(state.activityLikes, 'data', v);
    },
    setScrollBelow (state, v) {
      Vue.set(state, 'scrollBelow', v)
    },
    setBookmarkLoader (state, v) {
      Vue.set(state, 'isBookmarkLoading', v)
    },
    setIsReplying (state, v) {
      Vue.set(state, 'isReplying', v)
    },
    setFeedSingleItemReplies (state, v) {
      Vue.set(state, 'feedSingleItemReplies', v)
    },
    setIsLoadingFeedSingleComment (state, v) {
      Vue.set(state, 'isLoadingFeedSingleComment', v)
    },
    setFeedSingleItem (state, v) {
      Vue.set(state, 'feedSingleItem', v)
    },
    setFeedSingleItemActivities (state, v) {
      Vue.set(state, 'feedSingleItemActivities', v)
      // state.feedSingleItemActivities.activities.unshift(v)
    },
    setSingleFeed (state, v) {
      Vue.set(state, 'singleFeedView', v)
    },
    setActiveCareplan (state, v) {
      Vue.set(state, 'activeCareplan', v)
    },
    isLoadingPostActivity (state, v) {
      Vue.set(state, 'isLoadingPostActivity', v)
    },
    pushUserJournalFeed (state, v) {
      if (User.state.journalFeed.list.careplan_item)
        User.state.journalFeed.list.careplan_item.push(v)
    },
    pushResourceGroupFeed (state, v) {
      if (!_.isEmpty(Resource.state.groupFeed.list)) { Resource.state.groupFeed.list.careplan_item.push(v) }
    },
    pushPostFeedSingleCommentReply (state, data ) {
      var index = state.feedSingleItemActivities.activities.map(
        function(x) { return x.id; }
      ).indexOf(data.item_id);
      state.feedSingleItemActivities.activities[index].comment.comments.push(data);
    },
    pushPostFeedSingleComment (state, data) {
      // state.feedSingleItemActivities.activities.unshift(data)
      state.feedSingleItemActivities.activities.push(data)
    },
    setLikeActivity(state, v) {
      state.activityLikes.data.likes.length=0;
      state.activityLikes.data.likes=v.likes.users;
    },
    setIsLoadingLikesActivity(state, v) {
      Vue.set(state.activityLikes, 'isLikeActivityLoading', v);
    },
    likeComment(state, { v, isReply }) {
      if (!isReply) {
        var index = state.feedSingleItemActivities.activities.map(
          function(x) { return x.id; }
        ).indexOf(v.id);
        state.feedSingleItemActivities.activities.splice(index, 1, v);
      } else {
        var index = state.feedSingleItemActivities.activities.map(
          function(x) { return x.id; }
        ).indexOf(v.item_id);

        var indexReply = state.feedSingleItemActivities.activities[index].comment.comments.map(
          function(x) { return x.id; }
        ).indexOf(v.id);
        state.feedSingleItemActivities.activities[index].comment.comments.splice(indexReply, 1, v);
      }
    },
    deleteComment(state, { id, item_id }) {

      var index = state.feedSingleItemActivities.activities.map(
        function(x) { return x.id; }
      ).indexOf(id);

      if (index>-1) {
        state.feedSingleItemActivities.activities.splice(index, 1);
        return;
      }

      index = state.feedSingleItemActivities.activities.map(
        function(x) { return x.id; }
      ).indexOf(item_id);
      var indexReply = state.feedSingleItemActivities.activities[index].comment.comments.map(
        function(x) { return x.id; }
      ).indexOf(id);
      state.feedSingleItemActivities.activities[index].comment.comments.splice(indexReply, 1);

    },
    deletePostFeedSingleComment (state, id) {
      // state.feedSingleItemActivities.activities.splice(index, 1)
      var index = state.feedSingleItemActivities.activities.map(
        function(x) { return x.id; }
      ).indexOf(id);
      state.feedSingleItemActivities.activities.splice(index, 1)
    },
    deletePostFeedSingleCommentReply (state, { index, indexReply }) {
      state.feedSingleItemActivities.activities[index].comment.comments.splice(indexReply, 1)
    },
    pushLikeFeedSingleComment (state, { data, index }) {
      state.feedSingleItemActivities.activities.splice(index, 1, data)
    },
    pushLikeFeedSingleCommentReply (state, { data, index, indexReply }) {
      state.feedSingleItemActivities.activities[index].comment.comments.splice(indexReply, 1, data)
    },
    setFeaturedUsers (state, v) {
      Vue.set(state, 'featuredUser', v)
    },
    setIsFeaturedUsers (state, v) {
      Vue.set(state, 'isFeaturedUserLoading', v)
    },
    setFeaturedSearchUsers (state, v) {
      Vue.set(state, 'featuredSearchUser', v)
    },
    setRecentUsers (state, v) {
      Vue.set(state, 'recentUsers', v)
    },
    setRecentSearchUsers (state, v) {
      Vue.set(state, 'recentSearchUsers', v)
    },
    setMoreRecentSearchUsers (state, v) {
      state.recentSearchUsers.next_link = v.next_link;
      for (var x = 0; x < v.subscribers.length; x++) {
        state.recentSearchUsers.subscribers.push(v.subscribers[x]);
      }
    },
    setisLoadingRecentSearchUsers (state, v) {
      Vue.set(state, 'isLoadingRecentSearchUsers', v)
    },
    setisLoadingMoreRecentSearchUsers (state, v) {
      Vue.set(state, 'isLoadingMoreRecentSearchUsers', v)
    }
  },
  actions: {
    loadDocumentTypes (context) {
      return new Promise((resolve, reject) => {
        Axios.get(`${API.endpoints.base}documentcategory?brand_id=${Cons[0].BRAND_ID}`).then(
          res => {
            console.log("TARGET:", res)
            resolve(res.data);
          },
          error => {
            context.dispatch('exceptionHandling', { _err: error }, { root: 1 })
            reject(error);
          }
        );
      });
    },
    activityLikes({ commit, dispatch, state }) {
      return new Promise((resolve, reject) => {
        commit('setIsLoadingActivityLikes', true);
        Axios.get(API.endpoints.activity + '/' + state.singleFeedView.activity_id + '/likes').then(
          res => {
            commit('setIsLoadingActivityLikes', false);
            commit('setActivityLikes', res.data);
            resolve(res.data);
          },
          error => {
            commit('setIsLoadingActivityLikes', true);
            dispatch('exceptionHandling', { _err: error }, { root: 1 })
            reject(error);
          }
        );
      });
    },
    bookmarkItem ({ commit, dispatch }, { item, type }) {
      return new Promise((resolve, reject) => {
        commit('setBookmarkLoader', true)
        if (!item.bookmarked) {
          Axios.post(API.endpoints.bookmark, {
            item_id: item.id,
            type: 'careplan_item'
          }).then(
            res => {
              commit('setBookmarkLoader', false)
              dispatch("points/setUserActionPoints", {
                action: "bookmark",
                element_id: item.id
              }, {root: 1})
              resolve(res.data)
            },
            error => {
              commit('setBookmarkLoader', false)
              dispatch('exceptionHandling', { _err: error }, { root: 1 })
              reject(error)
            }
          )
        } else {
          Axios.delete(API.endpoints.bookmark + '/' + item.bookmark_id).then(
            res => {
              commit('setBookmarkLoader', false)
              resolve(res.data)
            },
            error => {
              commit('setBookmarkLoader', false)
              dispatch('exceptionHandling', { _err: error }, { root: 1 })
              reject(error)
            }
          )
        }
      })
    },
    postFeedSingleReply({ commit, dispatch, state }, { content, item_id }) {
      return new Promise((resolve, reject) => {
        var url = API.endpoints.activity;
        var data = {
          component: "activity",
          content: content,
          item_id: item_id,
          type: "activity_comment"
        };

        commit("setIsReplying", true);
        Axios({ method: "post", url: url, data: data }).then(
          res => {
            // console.log('postFeedSingleReply...', res.data);
            commit('pushPostFeedSingleCommentReply', res.data);
            commit("setIsReplying", false);
            resolve(res.data);
          },
          error => {
            commit("setIsReplying", false);
            dispatch("exceptionHandling", { _err: error }, { root: 1 });
            reject(error);
          }
        );
      });
    },
    likeActivity({ commit, dispatch, state }, {id, isLike}) {
      return new Promise((resolve, reject) => {
        var url = API.endpoints.activity + "/" + id + "/like";
        var method = isLike ? "post":"delete";
        commit('setIsLoadingLikesActivity', true);
        Axios({ method:method, url:url }).then(
          res => {
            if (isLike) {
              commit('setLikeActivity', res.data);
              dispatch("points/setUserActionPoints", {
                action: "like",
                element_id: id
              }, {root: 1})
            }
            setTimeout(() => {
              commit('setIsLoadingLikesActivity', false);
            }, 300);
            resolve(res.data);
          },
          error => {
            commit('setIsLoadingLikesActivity', false);
            dispatch("exceptionHandling", { _err: error }, { root: 1 });
            reject(error);
          }
        );
      });
    },
    likeFeedSingleComment({ commit, dispatch, state }, {id, isLike, isReply}) {
      return new Promise((resolve, reject) => {
        var url = API.endpoints.activity + "/" + id + "/like";
        var method = isLike ? "post":"delete";
        // console.log('param store...', [{id, isLike, isReply}])
        Axios({ method:method, url:url }).then(
          res => {
            if (isLike) {
              // console.log('isReply in commit...', isReply);
              commit('likeComment', { v: res.data, isReply: isReply });
              dispatch("points/setUserActionPoints", {
                action: "like",
                element_id: id
              }, {root: 1})
            }

            resolve(res.data);
          },
          error => {
            dispatch("exceptionHandling", { _err: error }, { root: 1 });
            reject(error);
          }
        );
      });
    },
    deleteFeedSingleComment({commit, dispatch, state}, {id, item_id}) {
      return new Promise((resolve, reject) => {
        Axios.delete(API.endpoints.activity + "/" + id).then(
          res => {
            commit('deleteComment', {id, item_id});
            resolve(res.data);
          },
          error => {
            dispatch("exceptionHandling", { _err: error }, { root: 1 });
            reject(error);
          }
        );
      });
    },
    postFeedSingleComment({ commit, dispatch, state }, { content, item_id }) {
      return new Promise((resolve, reject) => {
        var data = {
          component: "careplan_item",
          content: content,
          item_id: item_id,
          type: "careplan_item_comment"
        };

        commit("setIsReplying", true);
        Axios.post(API.endpoints.activity, data).then(
          res => {
            commit("pushPostFeedSingleComment", res.data);
            commit("setIsReplying",false);
            resolve(res.data);
          },
          error => {
            commit("setIsReplying", false);
            dispatch("exceptionHandling", { _err: error }, { root: 1 });
            reject(error);
          }
        );
      });
    },
    getFeedSingleReply({ commit, dispatch, state }, id) {
      return new Promise((resolve, reject) => {
        commit("base/setLoadingPage", true, { root: 1 });
        Axios.get(API.endpoints.activity + "/" + id + "/comments").then(
          res => {
            commit("setFeedSingleItemReplies", res.data);
            commit("base/setLoadingPage", false, { root: 1 });
            resolve(res.data);
          },
          error => {
            commit("base/setLoadingPage", false, { root: 1 });
            dispatch("exceptionHandling", { _err: error }, { root: 1 });
            reject(error);
          }
        );
      });
    },
    getFeedSingleComment({ commit, dispatch, state }, id) {
      return new Promise((resolve, reject) => {
        commit('base/setLoadingPage', true, {root:1});
        Promise.all([
          dispatch("getFeedSingleItem", id),
          dispatch("getFeedSingleItemActivities", id)
        ])
          .then(function(values) {
            commit('base/setLoadingPage', false, {root:1});
            resolve(values);
          })
          .catch(function(error) {
            commit('base/setLoadingPage', false, {root:1});
            dispatch("exceptionHandling", { _err: error }, { root: 1 });
            reject(error);
          });
      });
    },
    getFeedSingleItem ({ commit, dispatch, state }, id) {
      return new Promise((resolve, reject) => {
        commit('base/setLoadingPage', true, {root: 1})
        Axios.get(API.endpoints.item + '/' + id).then(
          res => {
            commit('setFeedSingleItem', res.data)
            commit('base/setLoadingPage', false, {root: 1})
            resolve(res.data)
          },
          error => {
            commit('base/setLoadingPage', false, {root: 1})
            dispatch('exceptionHandling', { _err: error }, { root: 1 })
            reject(error)
          }
        )
      })
    },
    getSingleItem ({ commit, dispatch, state }, id) {
      return Axios.get(API.endpoints.item + '/' + id)
    },
    getFeedSingleItemActivities ({ commit, dispatch, state }, id) {
      commit('base/setLoadingPage', true, {root: 1})
      return new Promise((resolve, reject) => {
        Axios.get(API.endpoints.item + '/' + id + '/activities').then(
          res => {
            commit('setFeedSingleItemActivities', res.data)
            commit('base/setLoadingPage', false, {root: 1})
            resolve(res.data)
          },
          error => {
            commit('base/setLoadingPage', false, {root: 1})
            dispatch('exceptionHandling', { _err: error }, { root: 1 })
            reject(error)
          }
        )
      })
    },
    loadFeed ({ commit, dispatch, state }, feedId) {
      return new Promise((resolve, reject) => {
        commit("setIsSingleFeedView", true);
        Axios.get(API.endpoints.item + '/' + feedId).then(
          res => {
            commit('setSingleFeed', res.data)
            commit("setIsSingleFeedView", false);
            resolve(res.data)
          },
          error => {
            dispatch('exceptionHandling', { _err: error }, { root: 1 })
            commit("setIsSingleFeedView", false);
            reject(error)
          }
        )
      })
    },
    getCareplanInfo ({ commit, dispatch, state }, payload) {
      return new Promise((resolve, reject) => {
        Axios.get(API.endpoints.careplan + '/' + payload).then(
          res => {
            console.log('feed.js getCareplanInfo...', res.data);
            commit('setActiveCareplan', res.data)
            resolve(res.data)
          },
          error => {
            reject(error)
          }
        )
      })
    },
    postCareplanUpdate ({ commit, dispatch, state }, payload) {
      return new Promise((resolve, reject) => {
        commit('isLoadingPostActivity', true)
        Axios.post(
          API.endpoints.careplan + '/' + payload.id + '/item',
          payload.data
        ).then(
          res => {
            commit('isLoadingPostActivity', false)
            resolve(res.data)
          },
          error => {
            reject(error)
            commit('isLoadingPostActivity', false)
          }
        )
      })
    },
    updateCareplanItem({ commit, dispatch, state}, payload){
      commit('user/setCategoryUpdateLoading', true, { root: true })
      return new Promise((resolve, reject) => {
        Axios.put(API.endpoints.careplan + '/' + payload.careplan_id + '/item/' + payload.id, payload)
        .then(
        res => {
          commit('user/setCategoryUpdateLoading', false, { root: true })
          resolve(res)
        }, error => {
          dispatch("exceptionHandling", { _err: error }, { root: 1 });
        })
      })
    },
    getFeaturedUsers ({ commit, dispatch, state }) {
      return new Promise((resolve, reject) => {
        commit('setIsFeaturedUsers', true)
        Axios.get(API.endpoints.careplan + '/' + Cons[0].GROUP_ID.featuredMembersBadgeId[process.env.VUE_APP_DEV_STATUS] + '/subscribers?sort_by=latest&brand_id=1').then(
          res => {
            commit('setFeaturedUsers', res.data)
            commit('setIsFeaturedUsers', false)
            resolve(res.data)
          },
          error => {
            commit('setIsFeaturedUsers', false)
            dispatch('exceptionHandling', { _err: error }, { root: 1 })
            reject(error)
          }
        )
      })
    },
    searchFeaturedUsers ({ commit, dispatch, state },text) {
      return new Promise((resolve, reject) => {
        commit('base/setLoadingPage', true, { root: 1 })
        Axios.get(API.endpoints.careplan + '/' + Cons[0].GROUP_ID.featuredMembersBadgeId[process.env.VUE_APP_DEV_STATUS] + '/subscribers?sort_by=latest&brand_id=1&search=' + text).then(
          res => {
            commit('setFeaturedSearchUsers', res.data)
            commit('base/setLoadingPage', false, { root: 1 })
            resolve(res.data)
          },
          error => {
            dispatch('exceptionHandling', { _err: error }, { root: 1 })
            commit('base/setLoadingPage', false, { root: 1 })
            reject(error)
          }
        )
      })
    },
    getRecentUsers ({ commit, dispatch, state }) {
      return new Promise((resolve, reject) => {
        Axios.get(API.endpoints.careplan + '/' + Cons[0].GROUP_ID.donate + '/subscribers?sort_by=latest&brand_id=1').then(
          res => {
            commit('setRecentUsers', res.data)
            resolve(res.data)
          },
          error => {
            dispatch('exceptionHandling', { _err: error }, { root: 1 })
            reject(error)
          }
        )
      })
    },
    searchRecentUsers ({ commit, dispatch, state },{text,group_id}) {
      return new Promise((resolve, reject) => {
        commit('base/setLoadingPage', true, { root: 1 })
        commit('setisLoadingRecentSearchUsers', true)
        Axios.get(API.endpoints.careplan + '/' + group_id + '/subscribers?sort_by=latest&brand_id=1&search=' + text).then(
          res => {
            commit('setRecentSearchUsers', res.data)
            commit('setisLoadingRecentSearchUsers', false)
            commit('base/setLoadingPage', false, { root: 1 })
            resolve(res.data)
          },
          error => {
            dispatch('exceptionHandling', { _err: error }, { root: 1 })
            commit('setisLoadingRecentSearchUsers', false)
            commit('base/setLoadingPage', false, { root: 1 })
            reject(error)
          }
        )
      })
    },
    loadMoreSearchRecentUsers ({ commit, dispatch, state },url) {
      return new Promise((resolve, reject) => {
        commit('setisLoadingMoreRecentSearchUsers', true)
        Axios.get(url).then(
          res => {
            commit('setMoreRecentSearchUsers', res.data)
            commit('setisLoadingMoreRecentSearchUsers', false)
            resolve(res.data)
          },
          error => {
            dispatch('exceptionHandling', { _err: error }, { root: 1 })
            commit('setisLoadingMoreRecentSearchUsers', false)
            reject(error)
          }
        )
      })
    },
    deleteItem ({ commit, dispatch, state },{careplanId,itemId}) {
      return new Promise((resolve, reject) => {
        Axios.delete(API.endpoints.base + "careplan/" + careplanId + '/item/' + itemId).then(
          res => {
            commit('resource/removeItem', itemId, { root: 1 })
            commit('user/removeActivity', itemId, { root: 1 })
            resolve(res.data)
          },
          error => {
            dispatch('exceptionHandling', { _err: error }, { root: 1 })
            commit('base/setLoadingPage', false, { root: 1 })
            reject(error)
          }
        )
      })
    }
  }
}
